import React, { ChangeEvent, useEffect, useState } from "react";
import useAlert from "@hooks/AlertHook";

type Props = {
    onChange: (files: Map<string, { json: File, image: File }>) => void
}

function ItemDirectoryPicker({ onChange }: Props) {
    const [itemsCount, setItemsCount] = useState<number>()
    const alert = useAlert()

    const handleFileChange = ({ target: { files } }: ChangeEvent<HTMLInputElement>) => {
        setItemsCount(undefined)
        setTimeout(() => alert.loading("Preparing files..."), 0)
        setTimeout(() => {
            if (!files) return alert.failed("Cannot read files");

            const fileArray = Array.from(files)
            const imageTemp: Map<string, File> = new Map()
            const jsonTemp: Map<string, File> = new Map()
            const validFiles: Map<string, { json: File, image: File }> = new Map()

            const checkFiles = (file: File, isJson: boolean) => {
                const onlyName = file.name.split('.').shift()!
                const size = file.size / 1024 / 1024;
                const files1 = isJson ? jsonTemp : imageTemp
                const files2 = isJson ? imageTemp : jsonTemp

                if (isNaN(Number(onlyName)) || size > 5) return;

                if (files2.has(onlyName)) {
                    const file2 = files2.get(onlyName)!;
                    validFiles.set(onlyName, {
                        image: isJson ? file2 : file,
                        json: isJson ? file : file2
                    })
                    files2.delete(onlyName)
                } else {
                    files1.set(onlyName, file)
                }
            }

            for (const file of fileArray) {
                const index = fileArray.indexOf(file) + 1;

                const isImage = file.type.startsWith("image/")
                const isJson = file.type == "application/json"

                if (isImage || isJson) checkFiles(file, isJson)
            }
            setItemsCount(validFiles.size)
            onChange(validFiles)
            alert.hide()
        }, 500)
    };

    return <>
        <div className="mb-6">
            <label className="mb-2 block font-display text-jacarta-700 dark:text-white">Files Directory</label>
            <p className="mb-3 text-2xs dark:text-gray-400">Upload your directory contains json and image. for example: 1.png, 1.json</p>

            <div className={`group relative flex max-w-md flex-col items-center justify-center rounded-lg border-2 border-dashed border-jacarta-100 bg-white ${itemsCount !== undefined ? "py-5 px-2" : "py-8 px-5"} text-center dark:border-gray-400 dark:bg-gray-900`}>

                <div className={`absolute inset-4 cursor-pointer rounded bg-jacarta-50 opacity-0 ${itemsCount !== undefined ? "" : "group-hover:opacity-100"} dark:bg-jacarta-600`}></div>

                {
                    itemsCount !== undefined && <p className="text-white">{itemsCount} Items</p>
                }

                {
                    itemsCount === undefined && <div className="relative z-10 cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="mb-4 inline-block fill-jacarta-500 dark:fill-white">
                            <path fill="none"
                                d="M0 0h24v24H0z" />
                            <path d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
                        </svg>
                        <p className="mx-auto max-w-xs text-xs dark:text-white">
                            Pick directory contains JSON metadata and image
                        </p>
                    </div>
                }


                <input onChange={handleFileChange} type="file"
                    /* @ts-expect-error */
                    directory=""
                    webkitdirectory=""
                    id="file-upload"
                    className="absolute inset-0 z-20 cursor-pointer opacity-0" />
            </div>
        </div>
    </>
}

export default ItemDirectoryPicker;